import React from "react";
import dayjs from "dayjs";
import { Box, Grid, Typography } from "@mui/material";

import { WSView } from "./WSView";
import { WSStatus } from "../Status/WSStatus";

// Define an interface for your component props
interface ViewProps {
  column: IInfoColumns[];
  data: any;
  labelStyle?: React.CSSProperties;
  header?: string;
  border?: boolean
}

export interface IInfoColumns {
  label: string;
  fieldName: string;
  type?: "none" | "status" | "date" | 'imageList'; // Default value handled in component
  style?: React.CSSProperties;
  isTooltip?: boolean;
}

// Define and export the memoized component
export const WSInfocard: React.FC<ViewProps> = React.memo(
  ({ data, column, labelStyle, header, border = true }) => {
    const sampleImages = [
      { img: "https://images.unsplash.com/photo-1549388604-817d15aa0110", title: "Bed" },
      { img: "https://images.unsplash.com/photo-1563298723-dcfebaa392e3", title: "Kitchen" },
      { img: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6", title: "Sink" },
    ];
    
    return (
      <Box
        sx={{
          border: border ? "1px solid #ccc" : undefined,
          borderRadius: "4px", // Rounded corners
          padding: "0px",
          marginBottom: "16px",
        }}
      >
        {/* Header */}
        {header && (
          <Box
            sx={{
              backgroundColor: "#7D79C2",
              padding: "9px",
              borderRadius: "4px 4px 0 0",
              marginBottom: "16px",
              textAlign: "start",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: "#fff",
                fontWeight: "bold",
                fontSize: "1rem",
              }}
            >
              {header}
            </Typography>
          </Box>
        )}

        {/* Content */}
        <Grid
          container
          spacing={2}
          sx={{ paddingLeft: 2, paddingBottom: 1.25, backgroundColor: "#fff", marginLeft: 0, marginRight: 0, width: 'auto' }}
        >
          {column?.map((item: IInfoColumns, index: number) => {
            const type = item?.type || "none"; // Default type

            return (
              <>
                {type !== 'imageList' && <React.Fragment key={index}>
                  {/* Label */}
                  <Grid item sm={3} xs={12}>
                    <WSView
                      title={item.label}
                      style={labelStyle || { fontSize: "1rem" }}
                    />
                  </Grid>

                  {/* Value */}
                  <Grid item sm={3} xs={12}>
                    {type === "date" && (
                      <Typography
                        style={item.style || { fontSize: "0.875rem", color: "gray" }}
                      >
                        {data[item.fieldName]
                          ? dayjs(data[item.fieldName])
                            .toDate()
                            .toLocaleDateString()
                          : "-"}
                      </Typography>
                    )}

                    {type === "none" && (
                      <WSView
                        title={data?.[item?.fieldName] ?? ''}

                        isTooltip={item.isTooltip}
                        style={item.style || { color: "gray" }}
                      />
                    )}

                    {type === "status" && (
                      <WSStatus value={data?.[item?.fieldName] ?? ''} />
                    )}
                  </Grid>

                </React.Fragment>}
              </>
            );
          })}
        </Grid>
      </Box>
    );
  }
);
